
import React from 'react'

import PropTypes from 'prop-types'

import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

// import LocationsMap from '@kolayyolla/shared/LocationsMap'

import { MapOutlined, Search, ViewAgendaOutlined } from '@mui/icons-material'
import { Avatar, IconButton, ListItem, ListItemAvatar, ListItemText,  Typography, useMediaQuery } from '@mui/material'
import { makeStyles, useTheme } from '@mui/styles'

import CardSkelaton from './CardSkelaton'
import Filters from './Filters'
import VenueCard from './VenueCard'

const ActiveOrders = React.lazy(() => import('../../components/ActiveOrders'))

const useStyles = makeStyles((theme) => {
  const classList = {
    root: {
      display: 'grid',
      gridTemplateColumns: '0.3fr 0.7fr',
      gridTemplateRows: 'auto 1fr',
      gap: 4,
      gridTemplateAreas: '"filter header" "filter cards"',

      [theme.breakpoints.only('xs')]: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: '1fr',
        gridTemplateAreas: '"filter" "header" "cards"'
      }
    },

    header: {
      gridArea: 'header'
    },
    headerBottom: {
      display: 'flex',
      backgroundColor: '#fafafa',
      flexDirection: 'row',
      alignItems: 'space-around',
      justifyContent: 'space-between',
      margin: theme.spacing(0, 1, -2, 1),
      padding: theme.spacing(1),
      borderRadius: theme.spacing(1),
      [theme.breakpoints.only('xs')]: {
        margin: theme.spacing(1, 1, -1, 1)
      }

    },

    filterColumn: {
      gridArea: 'filter',
      margin: theme.spacing(2, 1),
      [theme.breakpoints.only('xs')]: {
        margin: 0
      }

    },

    cards: {
      gridArea: 'cards',
      display: 'flex',
      flexWrap: 'wrap'
    },
    empty: {
      display: 'flex',
      height: '100%'
    }

  }

  return classList
})

const VenuesList = ({ list }) => {
  const classes       = useStyles()
  const theme         = useTheme()
  const navigate      = useNavigate()
  const isSmallScreen = useMediaQuery((t) => t.breakpoints.down('sm'))

  const venuesLoading = useSelector((state) => state.venues.isLoading)
  const activeOrders  = useSelector((state) => state.order.data.userOrders?.docs?.filter((o) => (o.status !== 'delivered' && o.status !== 'canceled' && o.status !== 'rejected')) || [])

  const renderEmpty = () => (
    <div className={classes.empty}>
      <ListItem component="div">
        <ListItemAvatar>
          <Avatar>
            <Search />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Aradığınız kriterlere uygun bir işletme bulamadık" secondary="Filtreleri temizleyip yeniden deneyebilirsiniz." />
      </ListItem>
    </div>
  )

  return (
    <div className={classes.root}>
      <div className={classes.filterColumn}>
          <Filters />
      </div>
      <div className={classes.header}>
        {
          activeOrders.length > 0 && <div style={{ margin: 8, width: '100%' }}><ActiveOrders orders={activeOrders} /></div>
        }
        <div className={classes.headerBottom}>
          {
            list.length > 0
              ? <Typography><strong style={{ color: theme.palette.primary.main }}>{list.length}</strong> tane işletme</Typography>
              : <Typography>...</Typography>
          }

          {
            !isSmallScreen && (
              <div>
              <IconButton sx={{ padding: 0 }} onClick={() => {}} ><ViewAgendaOutlined color={'primary' } /></IconButton>
              <IconButton sx={{ padding: 0 }} onClick={() => navigate({ hash: '#map' })} ><MapOutlined color={'action'}/></IconButton>
            </div>
            )
          }

        </div>
        </div>
      <div className={classes.cards}>

        {
          venuesLoading ? Array.from(Array(10).keys()).map((key) => <CardSkelaton key={key} />)
            : list.length > 0
              ? list.map((v) => <VenueCard key={v._id} venue={v} />)
              : renderEmpty()
        }
      </div>

    </div>
  )
}

VenuesList.defaultProps = {  list: [] }
VenuesList.propTypes    = {  list: PropTypes.array }

export default VenuesList
